// src/services/authHeader.js
import { useAuthStore } from "@/stores/authStore";

export default function authHeader() {
  const authStore = useAuthStore();
  const token = authStore.token;

  if (token) {
    return { Authorization: `Bearer ${token}` };
  } else {
    return {};
  }
}
